
export class OeeSettings {
    id: number | undefined;
    fKAccountId: number | undefined;
    fKCellId: number | undefined;
    defaultQualityRatio: number | undefined;
    defaultPlannedProductionTimeMin: number | undefined;
    cellName: string = "";
    LastRun: string | undefined;
    ignServer: string =""
    ignDb: string = "";
    ignTable: string = "";
    ignIndex: string = "";
    ignFieldValue: string = "";
    ignFieldError: string = "";
    ignUser: string = "";
    ignPwd: string = "";
    ignFieldTimestmp: string = "";
    ignScanRate: string = "";
    shortstopSeconds: string = "";
    ignFieldCell: string = "";
    name: string | undefined;
    supplier: string | undefined;
    description: string | undefined;
    status: string = "";
}
